<template>
  <div class="onboarding__header">
    <div class="mw-600 px-5 ml-auto mr-auto">
      <div class="onboarding__logo" title="Hauseful">
        <img class="onboarding__logo-symbol" :src="symbol" />
        <img class="onboarding__logo-type" :src="logo" />
      </div>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/images/logo-hauseful-type-dark.svg'
import symbol from '@/assets/images/logo-hauseful-symbol-dark.svg'

export default {
  name: 'OnboardingHeader',

  data() {
    return {
      symbol,
      logo,
    }
  },
}
</script>
